import axios from 'axios';
import { URL, getAuthorizationHeader, getAuthorizationHeaderUpload } from '../../constans/constants'
import { logout } from '../login/SesionService';

export const obtenerUnidad = (idUnidad) => {
  return axios.get(URL + 'organizacion/unidad/' + idUnidad, getAuthorizationHeader())
    .then(response => {
      return response.data;
    }, error => {
      if (error.response.status === 401) {
        logout();
      }
      return error;
    });
}

export const registrarUnidad = (unidad, idEmpresa) => {
  const json = {
    descripcion: unidad.descripcion,
    unidadPadre: unidad.unidadPadre,
    correoNotificacion: unidad.correoNotificacion,
    empresa: idEmpresa
  };
  return axios.post(URL + 'organizacion/agregarUnidad', json, getAuthorizationHeader())
    .then(response => {
      return response.data;
    }, error => {
      if (error.response.status === 401) {
        logout();
      }
      return error;
    });
}

export const editarUnidad = (unidad, idEmpresa) => {
  const json = {
    descripcion: unidad.descripcion,
    unidadPadre: unidad.unidadPadre,
    correoNotificacion: unidad.correoNotificacion,
    empresa: idEmpresa,
    id: unidad.id
  };
  return axios.post(URL + 'organizacion/editarUnidad', json, getAuthorizationHeader())
    .then(response => {
      return response.data;
    }, error => {
      if (error.response.status === 401) {
        logout();
      }
      return error;
    });
}

export const agregarMiembro = (miembro, idUnidad) => {
  return axios.post(URL + 'organizacion/agregarMiembro/' + idUnidad, miembro, getAuthorizationHeader())
    .then(response => {
      return response.data;
    }, error => {
      if (error.response.status === 401) {
        logout();
      }
      return error;
    });
}

export const eliminarUnidad = (idUnidad) =>{
  return axios.delete(URL + 'organizacion/unidad/' + idUnidad, getAuthorizationHeader())
  .then(response => {
    return response.data;
  }, error => {
    if (error.response.status === 401) {
      logout();
    }
    return error;
  });
}

